/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_TitleInputs */

const en_privacy_section_3_title = /** @type {(inputs: Privacy_Section_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. How We Use Your Data`)
};

const lv_privacy_section_3_title = /** @type {(inputs: Privacy_Section_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Kā mēs izmantojam Jūsu datus`)
};

/**
* | output |
* | --- |
* | "3. How We Use Your Data" |
*
* @param {Privacy_Section_3_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_title = /** @type {((inputs?: Privacy_Section_3_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_title(inputs)
	return en_privacy_section_3_title(inputs)
});